<template>
    <div class="image-overlay">
        <v-img src="/images/ci.svg" class="image-overlay__logo mx-auto" />
        <p class="image-overlay__title page-text"><slot/></p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.image-overlay{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &__logo{
        position: absolute;
        min-width: 140px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        opacity: .1;
    }
    &__title{
        text-align: center;
        color: #111;
        font-weight: 500;
    }
}
</style>